import { create } from "zustand";

const tilesData = new Map<string, Tile>([
  ["tile1", { id: "tile1", title: "Tile 1 Title" }],
  ["tile2", { id: "tile2", title: "Tile 2 Title" }],
  // Add more tiles as needed
]);

type Tile = {
  id: string;
  title: string;
};

type CommentOverlayStore = {
  isOverlayOpen: boolean;
  setIsOverlayOpen: (isOpen: boolean) => void;
  selectedTileId: string | null;
  setSelectedTileId: (id: string | null) => void;
  getTileById: (id: string) => Tile | null;
};

export const useCommentOverlayStore = create<CommentOverlayStore>((set) => ({
  isOverlayOpen: false,
  setIsOverlayOpen: (isOpen: boolean) => set({ isOverlayOpen: isOpen }),
  selectedTileId: null,
  setSelectedTileId: (id: string | null) => set({ selectedTileId: id }),
  getTileById: (id) => tilesData.get(id) || null,
}));
